(function($) {
    jQuery('.ekosysteemi-lightbox-close-icon').click(function(){
        var cardID = jQuery('.ekosysteemi-lightbox-content').data('contentid');
        jQuery('.ekosysteemi-lightbox-canvas').fadeOut(400, function(){
            jQuery('.ekosysteemi-lightbox-video iframe').attr('src', '');
        });
        jQuery('.ekosysteemi-lightbox-canvas').removeFocusTrap();
        jQuery('.path-card-'+cardID).focus().attr('aria-expanded', false);
        jQuery('html').removeClass('ekosysteemi-lightbox-noscroll');
        return false;
    });

    jQuery('.ekosysteemi-path').find('.path-card').each(function(){
        jQuery(this).click(function(e){
            var contentID = jQuery(this).attr("data-card-id");
            vkLightboxOpen(contentID);
            jQuery(this).attr('aria-expanded', true);
            return false;
        });
    });

    jQuery('.ekosysteemi-lightbox-arrow-left').click(function(){
        vkLightboxChangeSlide(false);
        return false;
    });
    jQuery('.ekosysteemi-lightbox-arrow-right').click(function(){
        vkLightboxChangeSlide(true);
        return false;
    });
})( jQuery );

function vkLightboxOpen(contentID){
    vkLightboxSetContent(contentID);
    jQuery('.ekosysteemi-lightbox-canvas').css("display", "flex").hide().fadeIn(400);
    jQuery('html').addClass('ekosysteemi-lightbox-noscroll');
    if(jQuery('.scrollToTop').is(":visible")){
        jQuery('.scrollToTop').hide();
    }
    jQuery('.ekosysteemi-lightbox-canvas').focusTrap();
}

function vkLightboxSetContent(contentID){
    var content = ekosysteemi_lightbox_content[contentID];
    jQuery('.ekosysteemi-lightbox-content').data('contentid', contentID);
    jQuery('.ekosysteemi-lightbox-title').text(content['title']);
    jQuery('.ekosysteemi-lightbox-video iframe').attr('src', content['video']);
    jQuery('.ekosysteemi-lightbox-text').empty().append('<p>'+content['text']+'</p>');
    for(var key in content['files']){
        jQuery('.ekosysteemi-lightbox-text').append('<p class="ekosysteemi-lightbox-file-link"><a href="'+content['files'][key]['url']+'" aria-label="Lataa tiedosto" target="_blank">'+content['files'][key]['title']+'</a></p>');
    }
}

function vkLightboxChangeSlide(forward){
    var currentContentID = parseInt(jQuery('.ekosysteemi-lightbox-content').data('contentid'));
    var count = Object.keys(ekosysteemi_lightbox_content).length;
    var changeTo = 0;
    if(forward){
        if(currentContentID == count){
            changeTo = 1;
        }else{
            changeTo = currentContentID + 1;
        }
    }else{
        if(currentContentID == 1){
            changeTo = count;
        }else{
            changeTo = currentContentID - 1;
        }
    }
    vkLightboxSetContent(changeTo);
}